// extracted by mini-css-extract-plugin
module.exports = {"Controls":"Controls_Controls__pcKfX","OrderButton":"Controls_OrderButton__dh79r","enable":"Controls_enable__1LETE"};